export const FILES_TYPES = {
  SOLICITATION: "Solicitation",
  AMENDMENT: "Amendment",
  REQUIREMENTS: "Requirements",
  CAPABILITY_STATEMENT: "Capability Statement",
  CPARS: "CPARS",
  DELIVERY_REPORT: "Delivery Report",
  UNKNOWN: "Unknown",
  OTHER: "Other",
  RESEARCH: "Research",
  PROPOSAL_WRITING: "Proposal Writing",
  WRITING_AND_EDITING: "Writing & Editing",
};

export const FILE_SOURCES = {
  ADDIN: "Add-in",
  LOCAL: "Local Files",
  FILE_SYSTEM: "Local Files",
  VT_EDITOR: "VT Editor",
  COLLECTIONS: "Collections",
  SHAREPOINT: "Sharepoint",
  SAM_GOV: "SAM.gov",
  SYSTEM: "System",
};

export const DOCUMENT_UPLOAD_ORIGIN = {
  PROPOSAL: "Proposal",
  OPPORTUNITY: "Opportunity",
  CONTRACT: "Contract",
};

export const ENTITY_TYPE = Object.freeze({
  OPPORTUNITY: "OPPORTUNITY",
  PROPOSAL: "PROPOSAL",
  CONTRACT: "CONTRACT",
  MISC_ANALYSIS: "MISC_ANALYSIS",
});

export const DOC_TYPE = Object.freeze({
  RESEARCH: "RESEARCH",
  PROPOSAL_WRITING: "PROPOSAL_WRITING",
  WRITING_AND_EDITING: "WRITING_AND_EDITING",
  AMENDMENT: "AMENDMENT",
  OTHER: "OTHER",
  UNKNOWN: "UNKNOWN",
});
